import { render, staticRenderFns } from "./diyDialog.vue?vue&type=template&id=08625b80&scoped=true"
import script from "./diyDialog.vue?vue&type=script&lang=js"
export * from "./diyDialog.vue?vue&type=script&lang=js"
import style0 from "./diyDialog.vue?vue&type=style&index=0&id=08625b80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08625b80",
  null
  
)

export default component.exports